import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createContentValidationSchema = Yup.object().shape({
  detectWord: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  replaceWord: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
